import { render, staticRenderFns } from "./FixListModel.vue?vue&type=template&id=55a58d44&scoped=true&"
import script from "./FixListModel.vue?vue&type=script&lang=js&"
export * from "./FixListModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a58d44",
  null
  
)

export default component.exports